export default __webpack_public_path__ + "static/media/36I-103555_-17650_0.04a0ac25.jpg";